var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 112,
    viewBox: "0 0 84 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3483_243)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5 0H10.5C4.70094 0 0 4.70094 0 10.5V101.5C0 107.297 4.70094 112 10.5 112H73.5C79.2991 112 84 107.299 84 101.5V10.5C84 4.70094 79.2969 0 73.5 0ZM42 35C49.7328 35 56 41.2672 56 49C56 56.7328 49.7328 63 42 63C34.2672 63 28 56.7219 28 49C28 41.2781 34.2781 35 42 35ZM63 91H21C19.0671 91 17.5 89.4329 17.5 87.5C17.5 77.8312 25.3312 70 35 70H49C58.6644 70 66.5 77.8356 66.5 87.5C66.5 89.425 64.925 91 63 91ZM52.5 21H31.5C29.575 21 28 19.4338 28 17.5C28 15.5662 29.575 14 31.5 14H52.5C54.425 14 56 15.5662 56 17.5C56 19.4338 54.425 21 52.5 21Z",
    fill: "#498CCE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3483_243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 112,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployee);
export default __webpack_public_path__ + "static/media/Employee.0299485a08e7e2f214a4e3fe74611b1f.svg";
export { ForwardRef as ReactComponent };